export default __webpack_public_path__ + "static/O0095-f0f71df078a02df7f5ac43f0b2966124.png";